export const featured = {
    id: 0,
    project: "FEATURED PROJECT",
    desc: "TOP-DOWN ACTION GAME",
    vid: "images/projects/featured project.webm",
    href: "https://github.com/Caferino/Area-51",
    tools: [
        "images/projects/icons/godot.svg",
        "images/projects/icons/ai.svg",
        "images/projects/icons/gimp.svg"
    ]
}

export const projects = [
    {
        id: 1,
        project: "TALECRAFT",
        desc: "BUILD-YOUR-OWN-ADVENTURE DESIGNER",
        href: "https://drive.google.com/file/d/1ODAgdfozNg_iz_-__uUq0opYTJwOIBie/edit",
        img: "images/projects/Interactive Stories.webp",
        tools: [
            "images/projects/icons/js.svg",
            "images/projects/icons/reactjs.svg"
        ]
    },
    {
        id: 2,
        project: "FULLSTACK QA",
        desc: "MAINTAINED ERP & CRM SYSTEMS AT UKKO",
        href: "https://planestrategico.conl.mx/",
        img: "images/projects/UKKO.webp",
        tools: [
            "images/projects/icons/ruby.svg",
            "images/projects/icons/js.svg",
            "images/projects/icons/sql.svg"
        ]
    },
    {
        id: 3,
        project: "CR++ COMPILER",
        desc: "DEVELOPED A HYBRID C++ & R COMPILER",
        href: "https://github.com/Caferino/Compilador-CR",
        img: "images/projects/CR.webp",
        tools: [
            "images/projects/icons/python.svg",
            "images/projects/icons/cpp.svg",
            "images/projects/icons/r.svg"
        ]
    },
    {
        id: 4,
        project: "ARDUINO",
        desc: "LABORATORY PRACTICE",
        href: "https://drive.google.com/file/d/1Ev2O4LmGfF9-vqaegnLgQ_i_YxS0HlR9/view?usp=sharing",
        img: "images/projects/Arduino.webp",
        tools: [
            "images/projects/icons/microchip.svg",
            "images/projects/icons/arduino.svg"
        ]
    },
    {
        id: 5,
        project: "NETWORKING",
        desc: "THE FUNDAMENTALS",
        href: "https://drive.google.com/file/d/1XZkWCVc9A3diW1g64vGWriDdMz5aVrPP/view?usp=sharing",
        img: "images/projects/Network.webp",
        tools: [
            "images/projects/icons/wireshark.svg",
            "images/projects/icons/cisco.webp"
        ]
    },
    {
        id: 6,
        project: "LUIGI KART",
        desc: "A SIMPLE UNITY GAME",
        href: "https://drive.google.com/file/d/1hx4S9XxGXpCoe2IqDUooR8bSCafBxL7K",
        img: "images/projects/Luigi Kart.webp",
        tools: [
            "images/projects/icons/unity.svg",
            "images/projects/icons/csharp.svg"
        ]
    },
    {
        id: 7,
        project: "HIV SIMULATOR",
        desc: "HIV IN MEXICO FORECAST SIMULATOR",
        href: "https://drive.google.com/file/d/1Ryf6JhDdrmvURKOR0n_RyAOL2Obw4c8M",
        img: "images/projects/HIV.webp",
        tools: [
            "images/projects/icons/python.svg",
            "images/projects/icons/latex.svg"
        ]
    },
    {
        id: 8,
        project: "TEC GO",
        desc: "DELIVERY APP FOR CAMPUS STUDENTS",
        href: "https://docs.google.com/presentation/d/1n_kF4PKt3XNbwJPkr1LxXw-wXF8oU82H/present?rtpof=true&sd=true&slide=id.p1",
        img: "images/projects/TecGO.webp",
        tools: [
            "images/projects/icons/ui.svg",
            "images/projects/icons/android-studio.svg"
        ]
    },
    {
        id: 9,
        project: "TWEET MINER",
        desc: "ANALYZES USER DATA FROM POST HISTORY",
        href: "https://docs.google.com/presentation/d/1e6iSCOsif0SrRHCySK-ECa15mWTtw2HV/present?usp=sharing&ouid=109175344616276574614&rtpof=true&sd=true",
        img: "images/projects/DB Course.webp",
        tools: [
            "images/projects/icons/python.svg",
            "images/projects/icons/sql.svg"
        ]
    },
    {
        id: 10,
        project: "FLUOROMETRY",
        desc: "IS MONTERREY'S AIR HEAVILY POLLUTED?",
        href: "https://drive.google.com/file/d/1t780toqem8oxZJMoHH_E9bzE8NSo7y6X/view?usp=sharing",
        img: "images/projects/Fluorometry Technique.webp",
        tools: [
            "images/projects/icons/world.svg",
            "images/projects/icons/microscope.svg"
        ]
    },
    {
        id: 11,
        project: "TABLEAU",
        desc: "DATA ANALYSIS WITH MICROSOFT SQL",
        href: "https://youtu.be/LRwSkdKbXcQ",
        img: "images/projects/Tableau.webp",
        tools: [
            "images/projects/icons/ms-sql.svg",
            "images/projects/icons/tableau.svg",
            "images/projects/icons/sql.svg"
        ]
    },
    {
        id: 12,
        project: "AGRITECH",
        desc: "THE FUTURE OF AGRICULTURE",
        href: "https://docs.google.com/presentation/d/19-aV5x0S16M915hX3eRXADlcgF5LA7Mx/present?usp=sharing&ouid=109175344616276574614&rtpof=true&sd=true",
        img: "images/projects/Agriculture.webp",
        tools: [
            "images/projects/icons/microchip.svg",
            "images/projects/icons/presentation.svg"
        ]
    },
    {
        id: 13,
        project: "CYBERSECURITY",
        desc: "THE BASICS OF CYBERSECURITY",
        href: "https://drive.google.com/file/d/11493ymK0ybKYIjwyl5c5KrS8eCMFbsjW/view?usp=sharing",
        img: "images/projects/Kali.webp",
        tools: [
            "images/projects/icons/kali.svg"
        ]
    },
    {
        id: 14,
        project: "R LANGUAGE",
        desc: "A COURSE ON AI & RESEARCH",
        href: "https://drive.google.com/file/d/1oQvSFYEWVvPoaPau7uP3qqY70BkcnuL0/view?usp=sharing",
        img: "images/projects/R.webp",
        tools: [
            "images/projects/icons/r.svg"
        ]
    },
    {
        id: 15,
        project: "ICE CREAM",
        desc: "FOR THE FAMILY'S BUSINESS",
        href: "https://i.imgur.com/eAbyqka.jpeg",
        img: "images/projects/Napolitano.webp",
        tools: [
            "images/projects/icons/ui.svg",
            "images/projects/icons/design.svg"
        ]
    },
    {
        id: 16,
        project: "RESILIENCIA",
        desc: "A ONE-MONTH PROJECT",
        href: "https://drive.google.com/file/d/1i4wbdJVBRkWj-VVRugDAghZXczMvKyPT/view?usp=sharing",
        img: "images/projects/Tutores de Resiliencia.webp",
        tools: [
            "images/projects/icons/ui.svg",
            "images/projects/icons/presentation.svg"
        ]
    },
    {
        id: 17,
        project: "DESIGN CLASS",
        desc: "MADE WITH PRIDE",
        href: "https://i.imgur.com/IufhlIu.png",
        img: "images/projects/Design.webp",
        tools: [
            "images/projects/icons/ui.svg",
            "images/projects/icons/design.svg"
        ]
    },
    {
        id: 18,
        project: "CHILE PIQUIN",
        desc: "A BRAND IDEA",
        href: "https://i.imgur.com/7I7h5Gv.jpeg",
        img: "images/projects/Chile.webp",
        tools: [
            "images/projects/icons/ui.svg",
            "images/projects/icons/design.svg"
        ]
    },
    {
        id: 19,
        project: "AMAZON AD",
        desc: "AN AD PROPOSAL FOR AMAZON MEXICO",
        href: "https://youtu.be/IuqfC32s0qo",
        img: "images/projects/Amazon.webp",
        tools: [
            "images/projects/icons/sony-vegas.svg",
            "images/projects/icons/presentation.svg"
        ]
    },
    {
        id: 20,
        project: "AANTAJ",
        desc: "AN AD FOR A MEDICINE CLASS PROJECT",
        href: "https://youtu.be/H7ENjpEamqQ",
        img: "images/projects/Aantaj.webp",
        tools: [
            "images/projects/icons/sony-vegas.svg",
            "images/projects/icons/design.svg"
        ]
    },
    {
        id: 21,
        project: "ALCOHOL",
        desc: "THE FIRST RANDOM RPG GAME I EVER MADE",
        href: "https://www.youtube.com/watch?v=t1r20j_d4wU",
        img: "images/projects/Alcohol.webp",
        tools: [
            "images/projects/icons/rpg-maker.svg",
            "images/projects/icons/sony-vegas.svg"
        ]
    },
];

/*  Project entry template, (edit id and everything else):
{
    id: #####,
    project: "PROJECT",
    desc: "DESCRIPTION",
    href: "",
    img: "images/projects/test.webp",
    tools: [
        "images/projects/icons/godot.svg",
        "images/projects/icons/godot.svg",
        "images/projects/icons/godot.svg"
    ]
},
*/